// Relative imports (not @/ aliases) on purpose: the catalog-parity test imports this
// module inside the Workers test pool, which doesn't resolve the client aliases.
import { SIDEBAR_SECTIONS } from "../../shared/sidebar-pages";
import { SECTION_ICONS } from "./section-icons";

export interface SearchItem {
  label: string;
  path: string;
  category: "page" | "product";
  icon?: React.ComponentType<{ className?: string }>;
}

/**
 * #914 (Akira's "search seems inconsistent" catch): the palette used to carry its OWN
 * hand-maintained page list, which drifted from the catalog — "Ops" found nothing
 * because Operations Traceability (plus BOM Explorer, Projects, RDTI, Commercial pages, …) was
 * never added. Pages now DERIVE from SIDEBAR_SECTIONS (#599 single source of truth):
 * a page added to the catalog is searchable by construction. Each row wears its
 * section's icon (per-page icons retired with the #914 sidebar rework). The
 * catalog-parity test (tests/route-catalog-coverage.test.ts) locks the coverage.
 */
const GENERIC_LABELS = new Set(["Dashboard"]);
const CATALOG_PAGE_ITEMS: SearchItem[] = SIDEBAR_SECTIONS.flatMap((section) =>
  section.pages
    .filter((p) => !p.divider)
    .map((p) => ({
      // "Dashboard" exists in two sections — prefix generic labels for a flat list.
      label: GENERIC_LABELS.has(p.label) ? `${section.label} ${p.label}` : p.label,
      path: p.path,
      category: "page" as const,
      icon: SECTION_ICONS[section.key],
    }))
);

// Tab deep-links into merged pages (#714/#715/#717) — not catalog pages themselves,
// so they're the one hand-maintained remainder. Each targets its tab directly.
const TAB_DEEP_LINKS: SearchItem[] = [
  { label: "Yield & Waste", path: "/materials?tab=waste", category: "page", icon: SECTION_ICONS.production },
  { label: "Purchase Orders", path: "/materials?tab=purchase-orders", category: "page", icon: SECTION_ICONS.production },
  { label: "Inventory Levels", path: "/materials?tab=inventory", category: "page", icon: SECTION_ICONS.production },
  { label: "Changeover Analysis", path: "/shifts?tab=changeovers", category: "page", icon: SECTION_ICONS.production },
  { label: "Supplier Quality", path: "/raw-materials?tab=supplier-quality", category: "page", icon: SECTION_ICONS.quality },
];

export const PAGE_ITEMS: SearchItem[] = [...CATALOG_PAGE_ITEMS, ...TAB_DEEP_LINKS];
